import { createContext, useContext } from "react";

import type { RadioGroupViewModel } from "./types-radio-group";

export const RadioGroupContext = createContext<RadioGroupViewModel | null>(null);

export function useRadioGroupContext(): RadioGroupViewModel {
  const context = useContext(RadioGroupContext);
  if (!context) throw new Error("RadioGroup.Item deve ser usado dentro de RadioGroup.Root");
  return context;
}
